// src/components/TemplateWorkspace/workspaceUploads/VideoPreview.jsx

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { auth, db } from '../../../../firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleExclamation,
  faHorse,
  faCoffee
} from '@fortawesome/free-solid-svg-icons';
import previewThumbnail from '../../../../assets/images/thumbnail/preview-thumbnail.png';
import './linkWorkspace.css';

const bumpQuips = [
  'bump-1.0 is crunching frames like popcorn',
  'bump-1.0 is deep in binge-watch mode',
  'bump-1.0 spotted a highlight reel',
  'bump-1.0 decoding pixels at warp speed',
  'bump-1.0 is vibing with your video',
  'bump-1.0 is surfing video waves',
  'bump-1.0 in full video snack mode',
  'bump-1.0 finding golden nuggets in footage',
  'bump-1.0 diving into the pixels',
  'bump-1.0 analyzing clips with swag',
  'bump-1.0 is surfing the video stream',
  'bump-1.0 crunching pixels for breakfast',
  'bump-1.0 vibing through your video frames',
  'bump-1.0 just spotted something epic',
  'bump-1.0 getting cozy with this footage',
  'bump-1.0 catching video waves',
  'bump-1.0 on a pixel-powered mission',
  'bump-1.0 busy turning clips into magic',
  'bump-1.0 tuning into your highlights',
  'bump-1.0 making sense of moving pictures',
];

const VideoPreview = ({
  details,
  content_id,
  isProcessing,
  errorMessage,
  isTranscriptError,
  done
}) => {
  const [percent, setPercent] = useState(0);
  const [quipIndex, setQuipIndex] = useState(
    () => Math.floor(Math.random() * bumpQuips.length)
  );
  const user = auth.currentUser;
  const docKey = `workspace-${content_id}`;

  // prime/reset
  useEffect(() => {
    setPercent(isProcessing ? 25 : 0);
  }, [isProcessing]);

  // subscribe to bump‐progress
  useEffect(() => {
    if (!user || !isProcessing || !content_id) {
      return;
    }

    const wsRef = doc(db, 'users', user.uid, 'workspaceContent', docKey);
    const unsub = onSnapshot(wsRef, snap => {
      if (!snap.exists()) {
        return;
      }
      const d = snap.data();
      const total =
        (d.total_audio_chunks || 0) + (d.expected_video_chunks || 0);
      const rec =
        (d.received_audio_chunks || 0) + (d.received_video_chunks || 0);
      const realPct =
        total > 0 ? Math.min(100, Math.round((rec / total) * 100)) : 0;

      setPercent(prev => Math.max(prev, realPct));
    });

    return () => unsub();
  }, [user, content_id, isProcessing]);

  // rotate quip
  useEffect(() => {
    if (!isProcessing) return;
    const iv = setInterval(() => {
      setQuipIndex(Math.floor(Math.random() * bumpQuips.length));
    }, 7000);
    return () => clearInterval(iv);
  }, [isProcessing]);

  return (
    <section className="worklink-workspace-video-details">
      <div className="worklink-video-card">
        <div className="worklink-video-overlay" />

        <div
          className="worklink-video-thumbnail-container"
          style={{ position: 'relative' }}
        >
          <img
            src={details.thumbnailUrl || previewThumbnail}
            alt="Video Thumbnail"
            className="worklink-video-thumbnail"
          />

          {/* Error overlay */}
          {isTranscriptError && (
            <div className="worklink-error-video-thumbnail-overlay">
              <div className="worklink-error-message-box">
                <div className="worklink-error-message">
                  <FontAwesomeIcon
                    icon={faCircleExclamation}
                    className="worklink-error-icon"
                  />
                  Try Again
                </div>
                <Link to="/workspace/new" className="worklink-reupload-button">
                  + Workspace
                </Link>
              </div>
            </div>
          )}

          {/* bump‐progress bar */}
          {!isTranscriptError && isProcessing && (
            <div className="links-progress-wrapper">
              <div className="bump-progress-bar">
                <div
                  className="bump-progress-fill"
                  style={{ width: `${percent}%` }}
                />
                <div
                  className="bump-progress-flag"
                  style={{ left: `${percent}%` }}
                />
                <FontAwesomeIcon
                  icon={faHorse}
                  className="bump-progress-horse"
                  style={{ left: `${percent}%` }}
                />
              </div>
              <div className="bump-progress-text">
                {bumpQuips[quipIndex]}{' '}
                <FontAwesomeIcon icon={faCoffee} className="bump-icon-coffee" />{' '}
                <span className="bump-percent">({percent}%)</span>
              </div>
            </div>
          )}

          {/* legacy errorMessage */}
          {!isTranscriptError && errorMessage && !done && (
            <div className="worklink-error-video-thumbnail-overlay">
              <div className="worklink-error-message-box">
                <div className="worklink-error-message">{errorMessage}</div>
                <div className="worklink-retry-message">
                  Learn more{' '}
                  <a
                    href="https://intercom.help/bumpups/en/articles/9126173-why-won-t-my-videos-process"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    here
                  </a>.
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Title only when done/not processing */}
        {!isProcessing && details.title && (
          <div className="worklink-video-title-DONE">
            <b>
              {details.title.length > 72
                ? `${details.title.slice(0, 72)}…`
                : details.title}
            </b>
          </div>
        )}
      </div>
    </section>
  );
};

export default VideoPreview;
